import PropTypes from 'prop-types'
import React, { useState } from 'react'

import { Modal } from '@/components/ui/Modal'
import { returnRepairOrderToIntake } from '@/services/repairOrders.service'
import { toast } from '@/utils/helpers'

/**
 *
 * ReturnToIntakeModal
 *
 * Confirms undoing "put on the Outstanding List" for an RO Intake order, returning it
 * to a clean intake state. OL-stage data (line items, comments) is cleared while the
 * audit log is preserved.
 *
 */
const ReturnToIntakeModal = ({ isOpen, setIsOpen, repairOrderId, dealerId, onSuccess }) => {
  const [loading, setLoading] = useState(false)

  const handleError = (message) => toast(message, 'error')

  const onConfirm = async () => {
    const response = await returnRepairOrderToIntake(
      dealerId,
      repairOrderId,
      setLoading,
      handleError,
      () => {},
    )

    if (response) {
      toast('Repair order returned to intake.', 'success')
      setIsOpen(false)
      onSuccess()
    }
  }

  return (
    <Modal
      open={isOpen}
      title="Return to Intake"
      setOpen={setIsOpen}
      loading={loading}
      onClose={() => setIsOpen(false)}
      content={
        <div className="mt-6 space-y-3">
          <p className="text-charcoal-900 text-sm">
            This removes the repair order from the Outstanding List and returns it to a clean
            intake state.
          </p>
          <p className="text-charcoal-700 text-sm">
            Its line items and comments will be cleared so it starts fresh if it&apos;s added back
            to the Outstanding List. This is kept in the audit log, but the action can&apos;t be
            undone from here.
          </p>
        </div>
      }
      actions={[
        {
          type: 'submit',
          label: 'Return to Intake',
          onClick: onConfirm,
        },
        { type: 'cancel', label: 'Cancel', onClick: () => setIsOpen(false) },
      ]}
    />
  )
}

export default ReturnToIntakeModal

ReturnToIntakeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  repairOrderId: PropTypes.string.isRequired,
  dealerId: PropTypes.string.isRequired,
  onSuccess: PropTypes.func.isRequired,
}
